import LazyLoad from "vanilla-lazyload";

export default class LazyLoadController {

    constructor() {
        this.init();
    }

    init() {

        this.lazyComponents = document.querySelectorAll(".js-lazy-load");

        if (this.lazyComponents.length < 1) {
            return;
        }

        const lazyLoadInstance = new LazyLoad({
            elements_selector: ".js-lazy-load",
        });

    }

}
